import { CollapsiblePanel, CollapsiblePanelProps } from "../CollapsiblePanel";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { ExpandingTooltip } from "../tooltips/ExpandingTooltip";

export { TooltipPanel, Props as TooltipPanelProps };

// TOOD: support headerChildren prop, so we can have buttons when using tooltip text
type Props = {
  tooltipText: ExpandingTooltip;
  /**
   * TODO: rename to something better. expandableTooltip ? this would cause the default to be unexpandable tooltips, probably better
   */
  shortTooltip?: boolean;
} & CollapsiblePanelProps;

const TooltipPanel = (props: Props) => {
  return (
    <CollapsiblePanel
      {...props}
      panelHeader={
        <>
          <AdvancedTooltip
            tooltipText={props.tooltipText}
            short={props.shortTooltip}
          >
            {(tProps) => <span {...tProps}>{props.title}</span>}
          </AdvancedTooltip>
          {props.headerChildren}
        </>
      }
    >
      {props.children}
    </CollapsiblePanel>
  );
};
